module.exports = __webpack_public_path__ + "img/1001980.2d6fa261.jpg";